import { v4 as uuidv4 } from "uuid";
export class UserProfileModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.email = "";
        this.profileImageUrl = "";
        this.tenantLogoUrl = "";
    }
}
export default class UserProfile extends UserProfileModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
